import React from 'react'

import Layout from '../components/layout'
import HomeTwo from '../components/home/HomeTwo'
import ServiceCapabilities from '../components/services/ServiceCapabilities'
import ServiceOneTeam from '../components/services/ServiceOneTeam'
import ServiceOtherSolutions from '../components/services/ServiceOtherSolutions'
import ServicePageHero from '../components/services/ServicePageHero'
import { APPLICATION_MODERNIZATION_CAPABILITIES_EN } from '../constants/serviceCapabilitiesApplicationModernization'
import { SERVICE_ONE_TEAM_APPLICATION_EN } from '../constants/serviceOneTeamContent'
import { SERVICE_OTHER_SOLUTIONS_EN } from '../constants/serviceOtherSolutionsContent'
import { SERVICE_HERO_ASSETS } from '../constants/serviceHeroAssets'

const ApplicationDevelopmentModernizationPageEn = props => (
  <Layout lang="en" title="Application Development & Modernization" meta={{ description: '' }} rootProps={{ className: 'page services service-application-modernization' }}>
    <div className="service-detail-page">
      <ServicePageHero
        sectionId="service-hero"
        label="Services"
        title={'Application Development & Modernization'}
        description={
          'From your first idea to a fully functional platform, we are with you at every step. We take responsibility for turning your vision into a best-in-class IT project.'
        }
        heroImage={SERVICE_HERO_ASSETS.app.src}
        imageAlt="Application development illustration"
        imageWidth={SERVICE_HERO_ASSETS.app.width}
        imageHeight={SERVICE_HERO_ASSETS.app.height}
      />
      <ServiceCapabilities
        idBase="service-capabilities-app-modernization"
        tabs={APPLICATION_MODERNIZATION_CAPABILITIES_EN}
        contactCtaIsEn
      />
      <HomeTwo lang="en" />
      <ServiceOneTeam
        idBase="service-one-team-app-modernization"
        {...SERVICE_ONE_TEAM_APPLICATION_EN}
      />
      <ServiceOtherSolutions
        idBase="service-other-solutions-app-modernization"
        {...SERVICE_OTHER_SOLUTIONS_EN}
      />
    </div>
  </Layout>
)

export default ApplicationDevelopmentModernizationPageEn
